import {getBaseUrl} from "./SecurityUtil"

export async function refreshAccessToken(refreshToken) {
    const redirectUrl = getBaseUrl();
    const data = new FormData();
    data.append('grant_type', 'refresh_token');
    data.append('client_id', '27988350-cd16-478b-9658-91b3788d091f');
    data.append('scope', 'api://firm-contact/user');
    data.append('refresh_token', refreshToken);
    data.append('redirect_url', redirectUrl);

    const requestOptions = {
        method: 'POST',
        body: data
    }

    const response = await fetch("https://login.microsoftonline.com/3bea478c-1684-4a8c-8e85-045ec54ba430/oauth2/v2.0/token", requestOptions);
    const responseJson = await response.json();
    return responseJson.access_token
}

